export default __webpack_public_path__ + "static/media/muzejLogo.3f40cbfb.svg";